import { ChangeDetectorRef, Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { routesData } from '../../resources/routes.constant';
import { filter } from 'rxjs/operators';
import { BackButton } from '../../interfaces/back-button.interface';
import { BackButtonService } from 'src/app/services/biometrics/back-button.service';
import { BIOMETRY_PATH } from '../../data/biometrics.constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  assetsUrl = environment.assetsUrl;
  whiteHeader: boolean = false;
  headerLanding: boolean = false;
  isBiometry: boolean = false;
  backButton: BackButton = {
    visible: false,
    to: ''
  };
  constructor(
    private backButtonService: BackButtonService,
    private router: Router,
    public ref: ChangeDetectorRef
  ) {
    this.observeRoutes();
  }

  observeBackButton() {
    this.backButtonService.backButton$.subscribe((b: BackButton) => {
      this.backButton = b;
    });
  }

  goTo(): void {
    this.router.navigate([this.backButton.to]);
  }

  observeRoutes() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const url = e.url.split('?')[0];
        this.isBiometry = url.includes(BIOMETRY_PATH);
        this.whiteHeader = url === routesData.CHANNEL_ENROLLMENT.redirectPath;
        this.headerLanding = url === routesData.HOME.redirectPath;
        this.ref.detectChanges();
      });
  }
}
